export const askNobiRoutes = {
  chat: "",
} as const;
